import * as React from 'react';

import classnames from 'classnames';

import {UpgradePillButton} from 'shells/limits/upgrade-pill-button';
import {Radio} from 'shells/radio/radio';

import type {EditionType} from './new-edition-modal';

import styles from './edition-type-selection.module.css';

type Props = {
    value: EditionType;
    label: string;
    sublabel: string;
    Icon: React.ComponentType<any>;
    disabled?: boolean;
    setShowFeatureGate?: (showFeatureGate: boolean) => void;
};

export function EditionTypeRadio(props: Props) {
    const {value, label, sublabel, Icon, disabled} = props;

    return (
        <Radio value={value} shouldWidthFitContent={true} size={15} disabled={disabled}>
            <div className={classnames('flex align-center', styles['radio-content'])}>
                <Icon size={15} wrapWithDiv={false} />
                <div className={disabled ? 'disabled no-click' : ''}>
                    <div className={styles['radio-label']}>{label}</div>
                    <div className={styles['radio-sublabel']}>{sublabel}</div>
                </div>
                {disabled && (
                    <UpgradePillButton
                        size='normal'
                        onClick={() => {
                            if (props.setShowFeatureGate) {
                                props.setShowFeatureGate(true);
                            }
                        }}
                    />
                )}
            </div>
        </Radio>
    );
}
